import { Card, CardBody } from 'reactstrap';

export const EmptySuspectedState = () => {
  return (
    <Card>
      <CardBody className="py-5 text-center">
        <div className="mb-3">
          <i className="ri-computer-line fs-1"></i>
        </div>
        <h5 className="mb-2">Configure os filtros para visualizar</h5>

        <p className="text-muted mb-0">
          Selecione os filtros desejados e clique em "Visualizar" para
          visualizar o relatório de atividades com indícios de manipulação de
          localização.
        </p>
      </CardBody>
    </Card>
  );
};
